var exports = {
  "R": "FocusRing.module__focusRing___RzRHQU",
};

module.exports = exports;
